import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpHelpService } from "../service/http-help.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { AddCustomerEndPoient } from "../service/global.service";
import { israelPhoneNumberValidator } from './../../validators/israelPhoneNumberValidator';
import { companyLabelHeEnAr } from '../../components/alldocuments/alldocuments-companies/companies.service';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { PaginationService } from 'ngx-pagination';

@Component({
	selector: "app-customers",
	templateUrl: "./customers.component.html",
	styleUrls: ["./customers.component.scss"]
})
export class CustomersComponent implements OnInit, OnDestroy {
	@Input() isInsideModal: boolean = false;

	curentLang: string = "";
	layoutVersion: any;
	userRegistId: any = JSON.parse(localStorage.getItem('user_id') || 'null');
	merchantId = JSON.parse(localStorage.getItem('merchant_id') || 'null');
	user_type = JSON.parse(localStorage.getItem('user_type') || 'null');
	term: any;
	p: any;
	addCustomer: FormGroup;
	updateCustomer: FormGroup;
	customersData: any = [];
	filteredCustomersData: any = [];
	customerDataMerchant: any = [];
	customerTypeData: any = [];
	customerId: number;
	updatedData: any;
	viewData: any;
	viewedCustomer: any = null;
	currentPage: number = 1;
	limit: number = 20;
	offset: number = 0;
	total: number = 0;
	public show: boolean = false;
	public validate = false;
	public updatevalidate = false;

	// Add Customer Modal properties
	showAddCustomerModal: boolean = false;
	customerModalMode: 'add' | 'update' = 'add';
	selectedCustomerData: any = null;

	private searchSubject = new Subject<string>();
	private destroy$ = new Subject<void>();

	private readonly paginationIds = ['customers-desktop', 'customers-mobile', 'customers-modal'];

	constructor(
		private spinner: NgxSpinnerService,
		public translate: TranslateService,
		private service: HttpHelpService,
		private modalService: NgbModal,
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private router: Router,
		private paginationService: PaginationService,
	) {
		this.curentLang = localStorage.getItem('curentLang') || 'he';
		this.merchantId = JSON.parse(localStorage.getItem('merchant_id') || 'null');
		this.user_type = JSON.parse(localStorage.getItem('user_type') || 'null');

		this.addCustomer = this.fb.group({
			customer_name_he: ['', Validators.required],
			customer_name_en: [''],
			customer_name_ar: [''],
			customer_type: [''],
			customer_phone: ['', [israelPhoneNumberValidator(7, 10)]],
			id_number: [null],
			customer_vat_number: [null],
			customer_vat_tax: [null],
			customer_address_str: [''],
			customer_address_str_ar: [''],
			customer_address_str_en: [''],
			customer_address_city: [''],
			customer_address_city_ar: [''],
			customer_address_city_en: [''],
			customer_address_zip_code: [''],
			customer_Building_number: [''],
			custom_text: [''],
		});

		this.updateCustomer = this.fb.group({
			customer_name_en: [''],
			customer_name_ar: [''],
			customer_name_he: ['', [Validators.required, Validators.maxLength(80)]],
			customer_address_str: ['', [Validators.maxLength(100)]],
			customer_address_str_ar: ['', [Validators.maxLength(100)]],
			customer_address_str_en: ['', [Validators.maxLength(100)]],
			customer_address_city: ['', [Validators.maxLength(100)]],
			customer_address_city_ar: ['', [Validators.maxLength(100)]],
			customer_address_city_en: ['', [Validators.maxLength(100)]],
			customer_address_zip_code: ['', [Validators.maxLength(20)]],
			customer_Building_number: ['', [Validators.maxLength(20)]],
			customer_phone: [null, [israelPhoneNumberValidator(7, 10)]],
			customer_vat_number: [null],
			customer_vat_tax: [null],
			id_number: [null],
			customer_type: [''],
			updated_by: [this.userRegistId],
			custom_text: [''],
		});
	}

	onCustomerTypeChange() {
		this.addCustomer.get('customer_type')?.valueChanges.subscribe(value => {
			if (value == 5) {
				this.addCustomer.get('customer_vat_number')?.clearValidators();
			} else if (value == 6) {
				this.addCustomer.get('customer_vat_number')?.clearValidators();
			}
			this.addCustomer.get('customer_vat_number')?.updateValueAndValidity();
		});
	}

	onPageChange(page: number) {
		const safePage = Math.max(1, Number(page) || 1);
		this.currentPage = safePage;
		this.syncPaginationInstances();
		const offset = (safePage - 1) * this.limit;
		this.loadCustomers(this.limit, offset, this.term || '');
	}

	loadCustomers(limit: number = this.limit, offset: number = 0, search: string = '') {
		this.spinner.show();
		this.service.getAllCustomersBasedOnMerchant(limit, offset, search).subscribe({
			next: res => {
				this.customersData = res.customers ?? [];
				this.total = Number(res.total ?? 0);
				this.limit = Number(res.limit ?? limit) || limit;
				this.offset = Number(res.offset ?? offset) || offset;
				this.currentPage = Math.floor(this.offset / this.limit) + 1;
				this.customersData.forEach((customer: any) => {
					if (customer.customer_phone) {
						customer.formattedPhone = this.formatPhoneNumber(customer.customer_phone);
					}
				});
				this.filteredCustomersData = [...this.customersData];
				this.syncPaginationInstances();
				this.spinner.hide();
			},
			error: () => {
				this.spinner.hide();
			}
		});
	}

	private syncPaginationInstances(): void {
		for (const id of this.paginationIds) {
			this.paginationService.register({
				id,
				itemsPerPage: this.limit,
				currentPage: this.currentPage,
				totalItems: this.total,
			});
			// register() alone does not notify pagination-controls; setCurrentPage emits change.
			this.paginationService.setCurrentPage(id, this.currentPage);
		}
	}

	get paginationPreviousLabel(): string {
		return this.curentLang === 'ar' ? 'السابق' : this.curentLang === 'he' ? 'הקודם' : 'Previous';
	}

	get paginationNextLabel(): string {
		return this.curentLang === 'ar' ? 'التالي' : this.curentLang === 'he' ? 'הבא' : 'Next';
	}

	getCustomerRowNumber(index: number): number {
		return this.offset + index + 1;
	}

	get pageReport(): string {
		if (!this.total) {
			return this.curentLang === 'ar'
				? 'لا يوجد عملاء'
				: this.curentLang === 'he'
					? 'אין לקוחות'
					: 'No customers';
		}
		const first = this.offset + 1;
		const last = Math.min(this.offset + this.customersData.length, this.total);
		if (this.curentLang === 'ar') {
			return `عرض ${first} إلى ${last} من ${this.total}`;
		}
		if (this.curentLang === 'he') {
			return `מציג ${first} עד ${last} מתוך ${this.total}`;
		}
		return `Showing ${first} to ${last} of ${this.total}`;
	}

	/** @deprecated use loadCustomers() instead */
	getAllCustomersBasedOnMerchant(limit?: number, offset?: number) {
		const l = limit ?? this.limit;
		const o = offset ?? (this.currentPage - 1) * this.limit;
		this.loadCustomers(l, o, this.term || '');
	}

	formatPhoneNumber(phoneNumber: string): string {
		const cleaned = phoneNumber.replace(/[^ \d]/g, '');
		if (!cleaned.endsWith('+')) {
			return `${cleaned}+`;
		}
		return cleaned;
	}

	get emptyCellDisplay(): string {
		return this.translate.instant('customers.table.emptyCell');
	}

	displayOptional(value: unknown): string {
		if (value === null || value === undefined) {
			return this.emptyCellDisplay;
		}
		const s = String(value).trim();
		return s === '' ? this.emptyCellDisplay : s;
	}

	customerDisplayName(item: any): string {
		const raw =
			this.curentLang === 'en'
				? item?.customer_name_en
				: this.curentLang === 'ar'
					? item?.customer_name_ar
					: item?.customer_name_he;
		const s = raw != null ? String(raw).trim() : '';
		if (!s) {
			return this.emptyCellDisplay;
		}
		return s;
	}

	customerDisplayNameShort(item: any): string {
		const raw =
			this.curentLang === 'en'
				? item?.customer_name_en
				: this.curentLang === 'ar'
					? item?.customer_name_ar
					: item?.customer_name_he;
		const s = raw != null ? String(raw).trim() : '';
		if (!s) {
			return this.emptyCellDisplay;
		}
		return s.length > 20 ? `${s.slice(0, 20)}\u2026` : s;
	}

	companyDisplayName(item: any): string {
		if (!item?.company) {
			return this.emptyCellDisplay;
		}
		const label = companyLabelHeEnAr(item.company).trim();
		return label ? label : this.emptyCellDisplay;
	}

	openAccountCard(item: any): void {
		const customerId = item?.customer_id;
		if (!customerId) {
			return;
		}
		const queryParams: Record<string, string> = {};
		const companyId = item?.company?.company_id;
		if (companyId != null) {
			queryParams.companyId = String(companyId);
		}
		this.router.navigate(['/dashboard/customers', customerId, 'account-card'], { queryParams });
	}

	openFeeAgreements(item: any): void {
		const customerId = item?.customer_id;
		if (!customerId) {
			return;
		}
		const queryParams: Record<string, string> = {
			customer_id: String(customerId),
		};
		const companyId = item?.company?.company_id;
		if (companyId != null) {
			queryParams.company_id = String(companyId);
		}
		this.router.navigate(['/dashboard/fee-agreements'], { queryParams });
	}

	customerTypeLabel(item: any): string {
		const t = Number(item?.customer_type);
		if (t === 6) {
			return this.translate.instant('customers.table.customerTypes.company');
		}
		if (t === 5) {
			return this.translate.instant('customers.table.customerTypes.individual');
		}
		return this.translate.instant('customers.table.customerTypes.unknown');
	}

	isUnknownCustomerType(item: any): boolean {
		const t = Number(item?.customer_type);
		return t !== 5 && t !== 6;
	}

	isCompanyCustomer(item: any): boolean {
		return Number(item?.customer_type) === 6;
	}

	viewYesNo(value: unknown): string {
		if (this.isAffirmative(value) === true) {
			return this.translate.instant('customers.modal.viewYes');
		}
		if (this.isAffirmative(value) === false) {
			return this.translate.instant('customers.modal.viewNo');
		}
		return this.emptyCellDisplay;
	}

	isAffirmative(value: unknown): boolean | null {
		if (value === true || value === 1 || value === '1' || value === 'true') {
			return true;
		}
		if (value === false || value === 0 || value === '0' || value === 'false') {
			return false;
		}
		return null;
	}

	viewInitial(item: any): string {
		const name = this.customerDisplayName(item);
		if (this.isEmptyCellText(name)) {
			return '?';
		}
		return name.charAt(0);
	}

	viewPhone(item: any): string {
		const raw = item?.customer_phone ?? item?.formattedPhone;
		if (raw == null || String(raw).trim() === '') {
			return this.emptyCellDisplay;
		}
		let digits = String(raw).replace(/\D/g, '');
		if (digits.startsWith('972')) {
			digits = digits.slice(3);
		}
		if (!digits) {
			return this.emptyCellDisplay;
		}
		return `+972 ${digits}`;
	}

	isEmptyCellText(text: string): boolean {
		return text === this.emptyCellDisplay;
	}

	getAllCustomerType() {
		this.spinner.show();
		this.service.getAllCustomerType().subscribe({
			next: res => {
				this.customerTypeData = res;
				this.spinner.hide();
			},
			error: error => {
				this.spinner.hide();
			}
		});
	}

	openXl(content?: any) {
		this.customerModalMode = 'add';
		this.selectedCustomerData = null;
		this.showAddCustomerModal = true;
	}

	openUpdateModal(customerData: any) {
		this.customerModalMode = 'update';
		this.selectedCustomerData = customerData;
		this.showAddCustomerModal = true;
	}

	onCustomerModalClose() {
		this.showAddCustomerModal = false;
		this.selectedCustomerData = null;
	}

	onCustomerModalSave(customerData: any) {
		this.showAddCustomerModal = false;
		this.selectedCustomerData = null;
		// Refresh the customer list
		this.getAllCustomersBasedOnMerchant();
	}

	/**
	 * Called on input event from the search box.
	 * Emits to the debounced search subject → triggers a server-side search.
	 */
	filterCustomers(): void {
		this.searchSubject.next(this.term || '');
	}

	isNumber(event: KeyboardEvent) {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			event.preventDefault();
		} else {
			return true;
		}
	}

	addedData() {
		if (this.addCustomer.invalid) {
			this.validate = true;
			Object.keys(this.addCustomer.controls).forEach(key => {
				const control = this.addCustomer.get(key);
});
			return;
		}

		const customerNameHe = this.addCustomer.get('customer_name_he')?.value;
		this.addCustomer.patchValue({
			customer_name_en: customerNameHe,
			customer_name_ar: customerNameHe
		});

		const customerAddressHe = this.addCustomer.get('customer_address_city')?.value;
		this.addCustomer.patchValue({
			customer_address_city_en: customerAddressHe,
			customer_address_city_ar: customerAddressHe
		});

		const customerAddressStreetHe = this.addCustomer.get('customer_address_str')?.value;
		this.addCustomer.patchValue({
			customer_address_str_en: customerAddressStreetHe,
			customer_address_str_ar: customerAddressStreetHe
		});

		let model = {
			customer_name_en: this.addCustomer.value.customer_name_en,
			customer_name_ar: this.addCustomer.value.customer_name_ar,
			customer_name_he: this.addCustomer.value.customer_name_he,
			customer_address_str: this.addCustomer.value.customer_address_str,
			customer_address_str_ar: this.addCustomer.value.customer_address_str_ar,
			customer_address_str_en: this.addCustomer.value.customer_address_str_en,
			customer_address_city: this.addCustomer.value.customer_address_city,
			customer_address_city_ar: this.addCustomer.value.customer_address_city_ar,
			customer_address_city_en: this.addCustomer.value.customer_address_city_en,
			customer_address_zip_code: this.addCustomer.value.customer_address_zip_code,
			customer_Building_number: this.addCustomer.value.customer_Building_number,
			customer_phone: this.addCustomer.value.customer_phone !== '' ? '+972' + this.addCustomer.value.customer_phone : '',
			customer_vat_number: this.addCustomer.value.customer_vat_number,
			customer_vat_tax: this.addCustomer.value.customer_vat_tax,
			id_number: this.addCustomer.value.id_number,
			customer_type: Number(this.addCustomer.value.customer_type),
			merchant_id: Number(this.merchantId),
			created_by: Number(this.userRegistId),
			custom_text: this.addCustomer.value.custom_text || null,
		};

		this.spinner.show();
		this.service.Post(AddCustomerEndPoient.POST, model).subscribe((res) => {
			if (res.status === 200) {
				Swal.fire({
					icon: 'success',
					title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
				});
				this.modalService.dismissAll();
				this.getAllCustomersBasedOnMerchant();
				this.getAllCustomerType();
				this.addCustomer.reset({
					customer_name_en: '',
					customer_name_ar: '',
					customer_name_he: '',
					customer_address_str: '',
					customer_address_str_ar: '',
					customer_address_str_en: '',
					customer_address_city: '',
					customer_address_city_ar: '',
					customer_address_city_en: '',
					customer_address_zip_code: '',
					customer_Building_number: '',
					customer_phone: '',
					customer_vat_number: null,
					customer_vat_tax: null,
					id_number: null,
					customer_type: null,
					custom_text: '',
				});
			} else if (res.status === 400 || res.status === 403 || res.status === 500) {
				let errorMessage;
				switch (res.status) {
					case 400:
					case 403:
					case 500:
						errorMessage = this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe);
						break;
					default:
						errorMessage = this.translate.instant('customers.notifications.unknownError');
				}
				Swal.fire({
					icon: 'error',
					title: errorMessage
				});
			}
			this.spinner.hide();
		});
	}

	updatedCustomerData() {
		let customerPhone = this.updateCustomer.value.customer_phone;
		if (customerPhone?.startsWith('0')) {
			customerPhone = customerPhone?.substring(1);
		}

		const requiredFields = [
			'customer_name_he',
		];

		for (const field of requiredFields) {
			if (!this.updateCustomer.get(field)?.value) {
				Swal.fire({
					icon: 'warning',
					title: this.translate.instant('customers.notifications.requiredFields')
				});
				this.updatevalidate = !this.updatevalidate;
				return;
			}
		}

		let merchantTaxNumber = this.updateCustomer.value.customer_vat_number;
		if (this.updateCustomer.value.customer_type != 5 && merchantTaxNumber !== null && merchantTaxNumber?.length < 9) {
			Swal.fire({
				icon: 'error',
				title: this.translate.instant('customers.notifications.vatNumberMinLength')
			});
			return;
		}

		let merchantPhone = this.updateCustomer.value.customer_phone;

		if (merchantPhone && merchantPhone !== '') {
			if (merchantPhone.length < 7) {
				Swal.fire({
					icon: 'error',
					title: this.translate.instant('customers.notifications.phoneMinLength')
				});
				return;
			}

			const validPrefixes = ['02', '04', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];
			let validationStartPhoneNumber = merchantPhone.substring(0, 2);

			if (!validPrefixes.includes(validationStartPhoneNumber)) {
				Swal.fire({
					icon: 'warning',
					title: this.translate.instant('customers.notifications.phonePrefix')
				});
				return;
			}
		}

		let customerPhoneFinal = this.updateCustomer.value.customer_phone;
		if (customerPhoneFinal?.startsWith('0')) {
			customerPhoneFinal = customerPhoneFinal?.substring(1);
		}

		const customerNameHe = this.updateCustomer.value.customer_name_he;
		this.updateCustomer.patchValue({
			customer_name_ar: customerNameHe,
			customer_name_en: customerNameHe
		});

		let model = {
			customer_name_en: this.updateCustomer.value.customer_name_en,
			customer_name_ar: this.updateCustomer.value.customer_name_ar,
			customer_name_he: this.updateCustomer.value.customer_name_he,
			customer_address_str: this.updateCustomer.value.customer_address_str,
			customer_address_str_ar: this.updateCustomer.value.customer_address_str_ar,
			customer_address_str_en: this.updateCustomer.value.customer_address_str_en,
			customer_address_city: this.updateCustomer.value.customer_address_city,
			customer_address_city_ar: this.updateCustomer.value.customer_address_city_ar,
			customer_address_city_en: this.updateCustomer.value.customer_address_city_en,
			customer_address_zip_code: this.updateCustomer.value.customer_address_zip_code,
			customer_Building_number: this.updateCustomer.value.customer_Building_number,
			customer_phone: this.updateCustomer.value.customer_phone !== '' ? '+972' + this.updateCustomer.value.customer_phone : '',
			customer_vat_number: this.updateCustomer.value.customer_vat_number,
			customer_vat_tax: this.updateCustomer.value.customer_vat_tax,
			id_number: this.updateCustomer.value.id_number,
			customer_type: Number(this.updateCustomer.value.customer_type),
			updated_by: Number(this.userRegistId),
			custom_text: this.updateCustomer.value.custom_text || null,
		};

		this.spinner.show();
		this.service.updateCustomersById(this.customerId, model).subscribe((res) => {
			if (res.status === 200) {
				Swal.fire({
					icon: 'success',
					title: this.curentLang === 'ar' ? res.messageAr :
						(this.curentLang === 'en' ? res.messageEn : res.messageHe)
				});
				this.modalService.dismissAll();
				this.getAllCustomerType();
				this.getAllCustomersBasedOnMerchant();
			} else if (res.status === 400 || res.status === 403 || res.status === 500) {
				let errorMessage;
				switch (res.status) {
					case 400:
						errorMessage = this.curentLang === 'ar' ? res.messageAr :
							(this.curentLang === 'en' ? res.messageEn : res.messageHe);
						break;
					case 403:
						errorMessage = this.curentLang === 'ar' ? res.messageAr :
							(this.curentLang === 'en' ? res.messageEn : res.messageHe);
						break;
					case 500:
						errorMessage = this.curentLang === 'ar' ? res.messageAr :
							(this.curentLang === 'en' ? res.messageEn : res.messageHe);
						break;
					default:
						errorMessage = this.translate.instant('customers.notifications.unknownError');
				}
				Swal.fire({
					icon: 'error',
					title: errorMessage
				});
			}
			this.spinner.hide();
		});
	}

	getCustomerTypeName() {
		const customerTypeId = this.addCustomer.get('customer_type')?.value;
		const selectedType = this.customerTypeData.find(item => item.lookup_detail_id === customerTypeId);
		return selectedType ? (this.curentLang === 'en' ? selectedType.lookupDetailEnName :
			(this.curentLang === 'ar' ? selectedType.lookupDetailArName : selectedType.lookupDetailHeName)) : '';
	}

	changeStatus(id: number, customer_status: any) {
		this.spinner.show();
		let model = {
			"customer_status": customer_status == 1 ? 59 : 1,
			"updated_by": this.userRegistId
		}
		this.service.changeCustomerStatus(id, model).subscribe(({
			next: res => {
				if (res.status == 200) {
					Swal.fire({
						icon: 'success',
						title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe),
					})
					this.getAllCustomersBasedOnMerchant();
					this.spinner.hide();
				}
			},
			error: err => {
				Swal.fire({
					icon: "error",
					title: err.error.message[0]
				});
				this.spinner.hide();
			}
		}))
	}

	setValue(customerId: number) {
		for (let i = 0; i < this.customersData.length; i++) {
			if (this.customersData[i].customer_id == this.customerId) {
				const selectedCategory = this.customersData.find(item => item.customer_id === customerId);

				this.updateCustomer.controls.customer_name_en.setValue(this.customersData[i].customer_name_en);
				this.updateCustomer.controls.customer_name_ar.setValue(this.customersData[i].customer_name_ar);
				this.updateCustomer.controls.customer_name_he.setValue(this.customersData[i].customer_name_he);
				this.updateCustomer.controls.customer_address_str.setValue(this.customersData[i].customer_address_str);
				this.updateCustomer.controls.customer_address_str_ar.setValue(this.customersData[i].customer_address_str_ar);
				this.updateCustomer.controls.customer_address_str_en.setValue(this.customersData[i].customer_address_str_en);
				this.updateCustomer.controls.customer_address_city.setValue(this.customersData[i].customer_address_city);
				this.updateCustomer.controls.customer_address_city_ar.setValue(this.customersData[i].customer_address_city_ar);
				this.updateCustomer.controls.customer_address_city_en.setValue(this.customersData[i].customer_address_city_en);
				this.updateCustomer.controls.customer_address_zip_code.setValue(this.customersData[i].customer_address_zip_code);
				this.updateCustomer.controls.customer_Building_number.setValue(this.customersData[i].customer_Building_number);

				let phone = this.customersData[i].customer_phone;
				if (phone?.startsWith('+972')) {
					phone = phone.slice(4);
				}
				this.updateCustomer.controls.customer_phone.setValue(phone);

				this.updateCustomer.controls.customer_vat_number.setValue(this.customersData[i].customer_vat_number);
				this.updateCustomer.controls.customer_vat_tax.setValue(this.customersData[i].customer_vat_tax);
				this.updateCustomer.controls.id_number.setValue(this.customersData[i].id_number);
				this.updateCustomer.controls.customer_type.setValue(this.customersData[i].customer_type);
				this.updateCustomer.controls.custom_text.setValue(this.customersData[i].custom_text || '');
			}
		}
	}

	executeFunctions(CustomerID: number, customerData: any) {
		this.openUpdateModal(customerData);
	}

	updateMd(paymentsUpdated: any) {
		this.modalService.open(paymentsUpdated, { size: 'xl', centered: true });
	}

	getId(id: number) {
		this.customerId = id;
	}

	executeFunctionsView(CustomerID: number, view: any) {
		this.viewedCustomer = this.customersData.find((item: any) => item?.customer_id == CustomerID) ?? null;
		this.viewData = view;
		this.getId(CustomerID);
		this.updateViewMd(this.viewData);
	}

	updateViewMd(paymentsUpdated: any) {
		this.modalService.open(paymentsUpdated, {
			centered: true,
			scrollable: true,
			windowClass: 'customer-view-dialog',
			modalDialogClass: 'customer-view-dialog__panel',
		});
	}

	openVerticallyCentered(dataDeleted: any) {
		this.modalService.open(dataDeleted, { centered: true });
	}

	deleteCustomerById() {
		this.spinner.show();
		this.service.deleteCustomerById(this.customerId).subscribe({
			next: (res) => {
				if (res.status == 400) {
					Swal.fire({
						icon: 'error',
						title: this.curentLang === 'ar' ? res.messageAr : (this.curentLang === 'en' ? res.messageEn : res.messageHe)
					});
					this.spinner.hide();
					return;
				} else {
					Swal.fire({
						icon: 'success',
						title: this.curentLang === 'ar' ? 'تم حذف الزبون بنجاح' : (this.curentLang === 'en' ? ' Customer deleted successfully' : 'הלקוח נמחק בהצלחה'),
					});
					this.getAllCustomerType();
					this.getAllCustomersBasedOnMerchant();
					this.modalService.dismissAll();
					this.spinner.hide();
				}
			},
			error: (err) => {
				Swal.fire(err.messageAr);
				this.spinner.hide();
			}
		});
	}

	ngOnInit() {
		this.onCustomerTypeChange();
		if (!this.addCustomer.value.customer_type) {
			this.addCustomer.patchValue({ customer_type: 5 });
		}

		// Server-side search with 400ms debounce (manual typing in search box)
		this.searchSubject.pipe(
			debounceTime(400),
			distinctUntilChanged(),
			takeUntil(this.destroy$)
		).subscribe(search => {
			this.currentPage = 1;
			this.loadCustomers(this.limit, 0, search);
		});

		// Deep link from Business Advisor etc.: ?search=customerName
		this.route.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(params => {
			const search = params.get('search')?.trim() ?? '';
			this.term = search;
			this.currentPage = 1;
			this.loadCustomers(this.limit, 0, search);
		});

		this.getAllCustomerType();
		this.layoutVersion = localStorage.getItem("layout_version");
		if (this.layoutVersion == null || this.layoutVersion == undefined) {
			localStorage.setItem("layout_version", "light-only");
			this.layoutVersion = "light-only";
		} else {
			this.layoutVersion = localStorage.getItem("layout_version");
			if (this.layoutVersion === "dark-only") {
				document.body.classList.add("dark-only");
			} else {
				document.body.classList.add("light-only");
			}
		}
		this.userRegistId = JSON.parse(localStorage.getItem('user_id') || 'null');
		this.merchantId = JSON.parse(localStorage.getItem('merchant_id') || 'null');
		this.user_type = JSON.parse(localStorage.getItem('user_type') || 'null');
		this.filteredCustomersData = [];
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
